<template>
  <div>
    <template v-if="job.masterFlag">
      <tab-buyer-console-fcl-container
        v-if="job.containerLoadType === 'BCF'"
        ref="tabContainer"
        :context="context"
        :action="action"
        :cooperate-edit="true"
        :container-config="containerConfig"
      />
      <template v-else>
        <tab-lcl-container-multi-so-no-mode
          v-if="masterCustomsDeclarationEnable"
          ref="tabContainer"
          :context="context"
          :action="action"
          :cooperate-edit="true"
          :container-config="containerConfig"
        />
        <tab-lcl-container
          v-else
          ref="tabContainer"
          :context="context"
          :action="action"
          :cooperate-edit="true"
          :container-config="containerConfig"
        />
      </template>
    </template>
    <tab-container
      v-else
      ref="tabContainer"
      :context="context"
      :action="action"
      :cooperate-edit="true"
      :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
      :container-config="containerConfig"
    />
  </div>
</template>

<script>
import tabContainer from '@/components/uiCustom/se/container/tabContainer'
import tabLclContainer from '@/components/uiCustom/se/container/tabLclContainer'
import tabBuyerConsoleFclContainer from '@/components/uiCustom/se/container/tabBuyerConsoleFclContainer'
import tabLclContainerMultiSoNoMode from '@/components/uiCustom/se/container/tabLclContainerMultiSoNoMode'

export default {
  name: 'SeContainer',
  components: {
    tabContainer,
    tabLclContainer,
    tabBuyerConsoleFclContainer,
    tabLclContainerMultiSoNoMode
  },
  props: {
    job: { type: Object, default: () => { } },
    context: { type: Object, required: true },
    action: { type: String, required: true },
    slaveCustomsDeclarationEnable: { type: Boolean, default: false }, // 【小票】关单信息 是否可用
    masterCustomsDeclarationEnable: { type: Boolean, default: false },
    containerConfig: { type: Object, default: () => { } }
  },
  mounted() {
    this.$emit('mounted')
  },
  methods: {
    onShow(row, isRefresh) {
      if (!this.$refs.tabContainer) {
        return
      }
      this.$refs.tabContainer.onShow(row, isRefresh)
    },
    async getSubmitData() {
      if (!this.$refs.tabContainer) {
        return {}
      }
      return await this.$refs.tabContainer.getSubmitData()
    }
  }
}
</script>

